module.exports = __webpack_public_path__ + "af12ea9c1b3e83f4e6dc56f01aebde49.otf";